import React, { useEffect, useState } from 'react'
import { authAxios } from '../../../helpers/axios'
import { toast } from 'react-toastify'
import { ErrorToast, InfoToast } from '../../../helpers/toasters'
import Input from '../../../components/Input'
import Popup from '../../../components/Popup'
import SmallPopup from '../../../components/SmallPopup'

export default function Grade({setShowManage,showManage}) {

    const [grades,setGrades] = useState([])
    const [showDeleteGrade,setShowCityDelete] = useState(false)
    const [deleting,setDeleting] = useState(false)

    async function getGrades(){

        try 
        {
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/grade`)
            if(res.data)
            {
                setGrades(res.data)
            }
        } catch (error) {
            console.log(error)
            toast('Error getting grades')
        }
    } 

    const onSubmit = async(e,data)=>
    {
        try 
        {
            e.preventDefault()
            let res;
            if(showManage.edit)
            {
                res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/grade/${data.id}`,{...data})  
            }
            else
            {
                res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/grade`,{...data}) 
                
            }
            if(res.data)
            {
                if(showManage.edit)
                {
                    setGrades(grades=>{
                        let prev = [...grades]
                        let itemIndex = prev.findIndex(item=>item.id === showManage.edit)
                        prev[itemIndex] = {...prev[itemIndex],name:res.data.name}
                        return prev;
                    })
                }
                else setGrades(grades=>([...grades,{...res.data}]))
                InfoToast(showManage.edit ? 'Grade Updated' : 'Grade Created',{position: toast.POSITION.BOTTOM_CENTER,hideProgressBar:true})
                setShowManage({type:null,status:false,edit:null})
            }
            else toast('error creating/updating grade')
        } catch (error) {
            console.log(error)
            ErrorToast(error.response.data.error.name)
        }
    }


    const onGradeDelete = async(e)=>
    {
        try 
        {
            e.preventDefault()
            setDeleting(true)
            await authAxios.delete(`${process.env.REACT_APP_BASE_URL}/grade/${showDeleteGrade}`) 
            getGrades()
            setShowCityDelete(false)
            setDeleting(false)
            InfoToast('City Deleted')
        } catch (error) {
            setDeleting(false)
            ErrorToast('City Deletion Failed')
            
        }
    }



    useEffect(()=>
    {
        getGrades();
    },[])


  return (
    <div className='flex flex-col w-full'>
        <div className='bg-white w-full flex-1 flex overflow-scroll'>
            <table className=' table-auto w-full flex-1 '>
                <thead className='bg-[#f9f9f9] w-full'>
                    <tr className='w-full'>
                    <td><p className='cursor-pointer flex items-center hover:text-black'>Grade Name</p></td>
                    <td><p className='cursor-pointer flex items-center hover:text-black'>Action</p></td>
                    </tr>
                </thead>
                <tbody>
                    {
                        grades.map((item,index)=>
                        {
                            return <tr>
                                <td className='capitalize'>
                                    <div>
                                        <p className='text-sm font-regular my-0'>{item.name}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                    <button className='btn-xs' onClick={()=>setShowManage({type:'grades',status:true,edit:item.id})}>Edit</button>
                                    <button className='btn-xs btn-red ml-1' onClick={()=>setShowCityDelete(item.id)}>Delete</button>
                                    </div>
                                </td>
                            </tr>
                        })
                    }
                </tbody>
            </table>
        </div>
        { showManage.status && showManage.type ==='grades' ? <ManageGrade setShow={setShowManage} onSubmit={onSubmit} edit={showManage.edit} /> : null}
        {showDeleteGrade ? <DeleteGrade submitting={deleting} onSubmit={onGradeDelete} onClose={setShowCityDelete}/> : null}
    </div>
  )
}

const DeleteGrade = ({onSubmit,onClose,submitting})=>
{
    return <SmallPopup submitting={submitting} formName={'deleteGrade'} title={'Delete City'} onClose={onClose} onSubmit={onSubmit} submitTitle={'Yes, Delete'}>
        <form className='w-full' onSubmit={(e)=>onSubmit(e)} id="deleteGrade">
            <div>
                <p className="text-sm">Are you sure you want to delete the grade?</p>
            </div>
        </form>
    </SmallPopup>
}



const ManageGrade = ({setShow,onSubmit,edit=false})=>
{
    const [grade,setGrade] = useState({id:null,name:''})
    const [loading,setLoading] = useState(edit ? true : false)
    useEffect(()=>
    {
        async function getGradeInfo(){
            if(edit)
            {
                let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/grade/${edit}`)
                console.log(res.data)
                setGrade({id:res.data.id,name:res.data.name})
                setLoading(false)
            }
        }
        getGradeInfo()
    },[])
    return loading ? 'loading' :<SmallPopup onClose={()=>setShow({type:null,status:false})}  title={edit ?  'Edit Grade' : 'Add Grade'} submitTitle={edit ? 'Update' : 'Add'} formName={'createGrade'}>
        <form className='w-full' onSubmit={(e)=>onSubmit(e,edit ? grade : {name:grade.name})} id="createGrade">
            <div>
                <label>Grade Name</label>
                <Input placeholder={'Enter Grade Name'} value={grade.name} setValue={(value)=>setGrade(grade=>({...grade,name:value}))} required={true}/>
            </div>
        </form>
    </SmallPopup>
}
